export enum SloStatus {
  Active = 'Active',
  Failing = 'Failing',
  Draft = 'Draft',
  Paused = 'Paused',
  Unspecified = 'Unspecified',
}
